import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import useUpdateDispatchStatus from '../../hooks/useUpdateDispatchStatus';
import { DISPATCH_STATUS, DISPATCH_STATUS_ENUM, DISPATCH_STATUS_MAP } from '../../constants/dispatch.enum';
import { useSecurity } from '@dfl/react-security';
import { DISPATCH_PERMISSIONS } from '../../constants';

type Props = {
  value: DISPATCH_STATUS_ENUM;
  rowId: string;
  readOnly?: boolean;
  button?: boolean;
};

const DispatchStatusPicker = ({ value, rowId, button, readOnly }: Props) => {
  const { t } = useTranslation('dispatch');
  const { hasPermission } = useSecurity();
  const { updateStatus, isLoading } = useUpdateDispatchStatus(rowId);

  // const allowedDestinations = DISPATCH_STATUS.filter((option) => {
  //   const fromStatuses = ALLOW_CHANGE_STATUSES[option._id as DISPATCH_STATUS_ENUM];
  //   return fromStatuses?.includes(value);
  // });
  // const filteredOptions =
  //   allowedDestinations.length > 0
  //     ? allowedDestinations
  //     : DISPATCH_STATUS;

  return (
    <Box
      sx={{
        '.MuiButton-root': {
          borderRadius: button ? '5px !important' : '30px',
        },
        '.MuiChip-root': {
          padding: '14px 10px',
          borderRadius: '50px',
        },
        button: {
          minWidth: 100,
          minHeight: button ? 36 : 'auto',
          alignItems: 'center',
          justifyContent: 'space-around',
          'MuiButton-endIcon': {
            marginLeft: '2px !important',
          },
        },
      }}
    >
      <StatusPicker
        readOnly={readOnly || !hasPermission(DISPATCH_PERMISSIONS.DISPATCH_WRITE)}
        options={DISPATCH_STATUS?.map((option) => ({
          ...option,
          title: t(option.title),
        }))}
        name='status'
        size={'small'}
        value={{
          ...(DISPATCH_STATUS_MAP?.get(value) as IStatus),
          title: t(DISPATCH_STATUS_MAP?.get(value)?.title as string),
        }}
        isLoading={isLoading}
        onChange={(status: any) => {
          updateStatus(status?._id);
        }}
      />
    </Box>
  );
};
export default memo(DispatchStatusPicker);
